import React from "react";

export default class PatientValue extends React.Component {
  propTypes: {
    children: PropTypes.node,
    placeholder: stringOrNode,
    value: PropTypes.object
  };
  render() {
    return (
      <div className="Select-value">
        <span className="Select-value-label">
          {this.props.value.nom} {this.props.value.prenom} ({this.props.value.matricule})
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/utilities/PatientValue.js